module.exports = __webpack_public_path__ + "static/media/sfl_5.bd0a415a.jpg";